import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { Observable } from 'rxjs/internal/Observable';

import { Resume } from '../models';

export interface ResumeApi {
  items: Resume[];
  total_count: number;
}

@Injectable({
  providedIn: 'root'
})
export class ResumeService {
  private _resumeRoute = '/api/resumes/';

  private headerOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

  constructor(
    private formBuilder: UntypedFormBuilder,
    private httpClient: HttpClient
  ) { }

  get(): Observable<Resume[]> {
    return this.httpClient.get<Resume[]>(this._resumeRoute);
  }


  getByUser(_userId: string): Observable<Resume[]> {
      return this.httpClient.get<Resume[]>(this._resumeRoute + _userId);
  }


  create(_resume: Resume): Observable<any> {
    return this.httpClient.post<any>(this._resumeRoute, JSON.stringify(_resume), this.headerOptions);
  }


  selectAllSearch(searchTerms: Resume): Observable<ResumeApi> {
    searchTerms['selectAll'] = true;
    return this.httpClient.post<ResumeApi>(this._resumeRoute + 'dataSourceSearch', JSON.stringify(searchTerms), this.headerOptions);
  }


  getCustomDatasource(searchParams, sortField, sortDirection, pageNumber: number, pageSize: number): Observable<ResumeApi> {
      searchParams['selectAll'] = false;
      searchParams.sortField = (sortField && sortField !== '') ? sortField : 'createdAt';
      searchParams.sortOrder = (sortDirection && sortDirection !== '') ? sortDirection : 'desc';
      searchParams.pageNumber = (pageNumber && pageNumber !== undefined) ? pageNumber : 0;
      searchParams.pageSize = (pageSize && pageSize !== undefined) ? pageSize : 10;

      return this.httpClient.post<ResumeApi>(this._resumeRoute + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions); 
  }


  update(_resume: Resume): Observable<any> {
    return this.httpClient.put<any>(this._resumeRoute, JSON.stringify(_resume), this.headerOptions);
  }


  markDelete(_id: string): Observable<any> {
    return this.httpClient.put(this._resumeRoute + 'mark-deleted/' + _id, this.headerOptions);
  }


  delete(_resume: Resume): Observable<any> {
    return this.httpClient.delete(this._resumeRoute + _resume._id, this.headerOptions);
  }


  resumeFormGroup(formData: Resume) {
    return this.formBuilder.group({
      title: [formData.title, Validators.required],
      url_path: [formData.url_path],
      user: [formData.user, Validators.required]
    });
  }
}